export enum LINK_TARGET{
    NewTab="newTab",
    SameTab="sameTab"
}